<highcharts-chart [options]="chartOptions"[Highcharts]="Highcharts" class="w-100 chart-size"></highcharts-chart>